export default __webpack_public_path__ + "static/media/premier-league-logo.cd49a164.png";